











































import overlays from '@/mixins/overlays'
import wrappers from '@/mixins/wrappers'
import mixins from 'vue-typed-mixins'
import { ContentItem } from '@/types/content'
import get from 'lodash/get'
import eventTracker from '@/utils/eventTracker'
export default mixins(overlays, wrappers).extend({
  name: 'LearningArticle',
  props: {
    id: String
  },
  data () {
    return {
      contentItem: null as ContentItem | null
    }
  },
  computed: {
    videoId (): string {
      const url = get(this.contentItem, 'cmsContent.videoUrl', '')
      const match = url.match(/watch\?v=(.+)|embed\/(.+)/)
      const videoId = match && Array.isArray(match) && match.length
        ? match.slice(1).filter(Boolean).pop()
        : null
      return videoId
    },
    wrapped (): Record<string, any> {
      return {
        toggleBookmark: this.offlineWrapper(this.toggleBookmark),
        refresh: this.offlineWrapper(this.refresh)
      }
    }
  },
  watch: {
    id: {
      async handler () {
        await this.wrapped.refresh()
      },
      immediate: true
    }
  },
  methods: {
    async refresh () {
      this.contentItem = await this.$store.dispatch(
        'user/content/GetContentItemById',
        { contentId: this.id }
      )
      if (this.contentItem) {
        eventTracker.track('LearnContent fullView', {
          contentId: this.contentItem.cmsContent.id,
          contentTitle: this.contentItem.cmsContent.title
        })
      }
    },
    async toggleBookmark () {
      (this.$refs.toggleBookmark as any).blur()
      const contentId = this.id
      const bookmarked = get(this.contentItem, 'userBookmarked', false)
      const contentTitle = get(this.contentItem, 'cmsContent.title')
      const undo = bookmarked
        ? Promise.resolve(false)
        : this.showSnackbar(this.$t('snackbars.articleBookmarked'), {
          showUndo: true
        })
      const bookmarkUpdated = await this.$store.dispatch(
        'user/content/UpdateBookmark',
        {
          contentId,
          value: !bookmarked,
          undo
        }
      )
      if (bookmarkUpdated) {
        eventTracker.track('LearnContent Bookmark', {
          contentId,
          contentTitle,
          bookmark: bookmarked ? 0 : 1
        })
      }
    }
  }
})
